// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"65":"b3fad57d","315":"7f4e3343","464":"8d3b588c","734":"df67f98a","752":"d150f6c0","806":"fc86d486","821":"b3fad57d"}[chunkId] + ".chunk.css";
};